<template>
  <div class="contents yuukyuu-kanri-list-search">
    <h2>有給休暇一覧</h2>
    <div class="search-area">
      <h3>検索項目</h3>
      <div class="item-container">
        <div class="col-item">
          <b class="title">検索種別</b>
          <input-radio :options="searchOptions" v-model="searchForm.searchDiv"></input-radio>
        </div>
        <div class="work-place" v-show="searchForm.searchDiv == 2">
          <select-box :options="syuugyouBasyoOptions" v-model="searchForm.syuugyouBasyoId"></select-box>
        </div>
      </div>
      <div class="btn-container">
        <button type="button" class="btn clear" @click="clear">クリア</button>
        <button type="button" class="btn primary" @click="search()"><i class="fa-solid fa-magnifying-glass"></i>検索</button>
      </div>
    </div>
    

    <component :is="List" :searchForm="searchForm" :list="list" :isLoading="isLoading" />
    <!--button-container-->
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref, Ref } from "vue";
import { useInit } from "@/composable/yuukyuu/list/init";
import { useYuukyuuList } from "@/composable/yuukyuu/list/list";
import { useForm } from "@/composable/form/form";
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init";
import List from "@/components/yuukyuukanri/List.vue";
import { useYuukyuuKanriStore } from '@/store/yuukyuu-kanri'

export default defineComponent({
  setup() {
    // 初期化
    const { searchForm, searchOptions, list } = useInit();
    const { getList, isLoading } = useYuukyuuList();
    const yuukyuuKanriStore = useYuukyuuKanriStore();
    const { syuugyouBasyoOptions, getAllSyuugyouBasyoOptions } = useSyuugyouBasyoInit();

    onMounted(async () => {
      searchForm.value = yuukyuuKanriStore.item

      // 有給休暇一覧取得
      list.value = await getList(searchForm.value);
      
      await getAllSyuugyouBasyoOptions()
      if(syuugyouBasyoOptions.value.length > 0){
        searchForm.value.syuugyouBasyoId = syuugyouBasyoOptions.value[0].val
      }
    });

    // コンポーネント（一覧）
    const List = computed(() => {
      return "list";
    });

    // 検索ボタンクリック
    const search = async() => {
      yuukyuuKanriStore.setItem(searchForm.value);
      list.value = await getList(searchForm.value);
    }

    // クリアボタンクリック
    const clear = () => {
      searchForm.value = {
        searchDiv: 1,
        syuugyouBasyoId: syuugyouBasyoOptions.value[0].val
      }
    }

    // エラー取得
    const { getError } = useForm();

    return {
      getError,
      isLoading,
      List,
      searchForm,
      searchOptions,
      syuugyouBasyoOptions,
      search,
      clear,
      list,
    };
  },
  components: {
    list: List,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/yuukyuu-list.scss';
</style>